import { Pipe, PipeTransform } from '@angular/core';
import { TranslationService } from './Translation.service';

/**
 * translate-format-locale pipe
 *
 * Import using the TranslationsModule
 *
 * Usage in the template file:
 * {{ 'my.key' | translateFormatLocale: language : param1 : param2 }}
 *
 * Each additional parameter is separated with a semi-colon (:)
 */
@Pipe({
    name: 'translateFormatLocale',
    standalone: false
})
export class TranslateFormatLocalePipe implements PipeTransform {
    constructor(private TR: TranslationService) {}

    /**
     * Translate the key value using a formatted string.
     *
     * @param key The key to translate
     * @param languageCode Language code to enforce for the translation
     * @param params Items to replace in the formatted string
     *
     * @returns Translated string
     */
    transform(key: string, languageCode: string, ...params: any[]): string {
        const translatedValue = this.TR.keyFormatterLocale(
            key,
            languageCode,
            ...params
        );
        return translatedValue;
    }
}
